export default "__VITE_ASSET__DStdAour__"